<template>
  <div id="app" class="root-app-wrapper">
    <div class="mobile-trigger" @click="OpenSideNav()">
      <i class="las la-bars"></i>
    </div>
    <SIDENAV></SIDENAV>
    <vue-page-transition name="fade-in-right">
      <router-view></router-view>
    </vue-page-transition>
  </div>
</template>

<script>
import SIDENAV  from './components/global/side_nav'

export default {
  name: 'App',
  watch:{
    $route (to, from){
      $('#app-sidenav').removeClass('_active')
      $('.sidenav-backdrop').removeClass('_active')
    }
  },
  methods: {
    OpenSideNav() {
     $('#app-sidenav').addClass('_active')
     $('.sidenav-backdrop').addClass('_active')
    }
  },
  components:{SIDENAV}
}
</script>

<style>
@import "./assets/styles/main.min.css";
</style>



// WEBPACK FOOTER //
// src/App.vue